<template>
  <div v-if="manualCombineResultCardList.length">
    <div class="card-list">
      <transition-group name="list" tag="div">
        <v-row
          class="pa-0 ma-0 mb-1"
          v-for="result in manualCombineResultCardList"
          :key="result.jobId"
        >
          <manual-combine-result-card :manualCombinationResult="result" />
        </v-row>
      </transition-group>
    </div>
  </div>
</template>
<style scoped lang="scss">
.card-list {
  position: fixed;
  left: 54px;
  bottom: 35px;
  width: 460px;
  max-height: 35vh;

  z-index: 5;

  overflow-y: auto;
  overflow-x: hidden;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.25s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
<script lang="ts">
import { mapGetters } from 'vuex';
import ManualCombineResultCard from './ManualCombineResultCard.vue';

export default {
  name: 'ManualCombineResultCardList',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('app', ['manualCombineResultCardList'])
  },
  components: {
    ManualCombineResultCard
  }
};
</script>
